import { useSelector } from 'react-redux'
import { booleanRenderPropertySelector } from '~/app/store/config'
import { RenderProperty } from 'shared/renderProperties'

export const useShowFavorites = (): boolean => {
  const booleanRenderProperty = useSelector(booleanRenderPropertySelector)

  return booleanRenderProperty(RenderProperty.Favorites)
}
